$(() => {
    $('[data-backward="true"]').on("click", (event) => {
        event.preventDefault();
        if (document.referrer) {
            window.location.href = document.referrer;
            return;
        }
        //Hvis referrer ikke findes, brug back
        if (window.history) {
            window.history.back();
            return;
        }
        //Hvis alt andet fejler, hop videre til den definerede url
        window.location.href = $(event.target).prop("href");
    });
});